'use client';

import { FC } from 'react';

import { AssetUtils } from '@ravago/shared/next-data-access';
import { DisplayOrder, OrderLineOpenedFrom } from '@ravago/shared/page-data/models/elements';
import { AspectRatio } from '@ravago/shared/radiance/components/aspect-ratio/components/AspectRatio/AspectRatio';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Icon } from '@ravago/shared/radiance/components/icon/components/Icon/Icon';
import { Image } from '@ravago/shared/radiance/components/image/components/Image/Image';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useFormatter } from '@ravago/shared/translations/client';

interface Props {
   order: DisplayOrder;
   openedFrom: OrderLineOpenedFrom;
   acceptWebp?: boolean;
}

export const OrderLineItem: FC<Props> = ({ order, openedFrom, acceptWebp }) => {
   const format = useFormatter();

   return (
      <Box spacing={{ left: '2xs' }} gap="md">
         {openedFrom !== 'order_overview_order' && openedFrom !== 'order_overview_shipment' && (
            <Box>
               <AspectRatio aspectRatio="1:1">
                  <Image
                     src={
                        order.contentfulProduct?.brand?.producer?.logo?.url
                           ? AssetUtils.optimizeImageIfRequired(order.contentfulProduct.brand.producer.logo.url, acceptWebp)
                           : '/images/placeholders/default-logo.png'
                     }
                     alt={order.product.description}
                     title={order.product.description}
                     height="52px"
                     width="52px"
                     objectFit="contain"
                  />
               </AspectRatio>
            </Box>
         )}
         <Box direction="column" gap="none" justify="center" items="start" wrap="wrap">
            <Typography component="span" variant="body-highlight">
               {order.product.description}
            </Typography>
            <Box gap="2xs">
               <Icon size="caption" color="subtle" icon="weight-hanging" />
               <Typography component="span" variant="small" color="subtle">
                  {format.quantity(order.quantity)}
               </Typography>
            </Box>
         </Box>
      </Box>
   );
};
